"use client";
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import * as React from 'react';
import { Icon } from '../../Icon/Icon.web.js';

var _excluded = ["color", "size"];
var IconInfograph = function IconInfograph(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === undefined ? 'currentColor' : _ref$color,
    _ref$size = _ref.size,
    sizeProp = _ref$size === undefined ? '24px' : _ref$size,
    props = _objectWithoutProperties(_ref, _excluded);
  var size = sizeProp;
  return /*#__PURE__*/React.createElement(Icon, props, /*#__PURE__*/React.createElement("svg", {
    fill: "none",
    viewBox: "0 0 24 24",
    width: size,
    height: size
  }, /*#__PURE__*/React.createElement("path", {
    fill: color,
    d: "m4 18.41 3.13-3.12 3.46 2.3 2.26-7.94 3.42-2.04 1.32 7.49 3.36 2.23L22 15.67l-2.59-1.77-1.68-9.51-6.58 3.96-1.74 6.06-2.54-1.7L4 15.59V2H2v20h20v-2H4z"
  })));
};

export { IconInfograph, IconInfograph as default };
